import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { businessRoutes } from "./modules/business/businessRoutes";
import { billingRoutes } from "./modules/billing/billingRoutes";
import { myAccountRoutes } from "./modules/myaccount/myaccountRoutes";
import { authRoutes } from "./modules/auth/authRoutes";
import ProtectedRoute from "./ProtectedRoute";

const AppRouter = () => {

    const { accessToken, isLoggedIn, tenants } = useSelector((state) => state?.auth);

   
   

    const protectedRoutes = [
        ...businessRoutes,
        ...billingRoutes,
        ...myAccountRoutes
    ]

    const installRoutes = [...authRoutes];
    return (
        <Routes>
            {
                //unprotected or auth routes
                installRoutes.map((route, index) => {
                    return route.element ? (
                        <Route
                            key={index}
                            exact={true}
                            path={route.path}
                            element={route.element}
                        />
                    ) : null;
                })
            }
            {protectedRoutes.map((route, index) => {
                return route.element ? (
                    <Route
                        key={index}
                        exact={true}
                        path={route.path}
                        element={
                            route.isProtected ? (
                                <ProtectedRoute
                                    isLoggedIn={isLoggedIn}

                                >
                                    {route.element}
                                </ProtectedRoute>
                            ) : (
                                <Navigate replace to={"auth/login"} />
                            )
                        }
                    />
                ) : null;
            })}
            <Route
                path="/"
                exact={true}
                element={
                    <Navigate
                        replace
                        to={
                            isLoggedIn &&
                                accessToken &&
                                tenants.length > 0
                                ? "business"
                                : "auth/login"
                        }
                    />
                }
            />
            <Route path="*" element={<Navigate replace to={"/"} />} />
        </Routes>
    );
};

export default AppRouter;
